import { FunctionComponent, useCallback, useMemo, ChangeEvent } from 'react'
import { observer } from 'mobx-react-lite'
import { makeStyles } from '@griffel/react'
import { Switch, SwitchOnChangeData } from '@fluentui/react-switch'
import { Field } from '@fluentui/react-field'
import { Checkbox, CheckboxOnChangeData } from '@fluentui/react-checkbox'
import { IFilter } from '@knowmax/genericlist-core'
import { useGenericListSettings, getParamId } from '@knowmax/genericlist-core'

const useClasses = makeStyles({
  horizontal: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
})

const VALUETRUE = 'true'
const VALUEFALSE = 'false'

/** Renders filter for boolean value. */
export const FilterBoolean: FunctionComponent<{ filter: IFilter, listId?: string }> = observer(({ filter, listId }) => {
  const classes = useClasses()
  const settings = useGenericListSettings()
  const filterparamid = useMemo(() => getParamId(filter.id, listId), [filter.id, listId])

  const checked = useMemo(() => {
    const value = settings.params.get(filterparamid) ?? undefined

    return (value === VALUETRUE || value === '1') ? true :
      (value === VALUEFALSE || value === '0') ? false :
        undefined
  }, [filter, settings.params])

  const enabled = useMemo(() => checked !== undefined, [checked])

  const toggle = useCallback((ev: ChangeEvent<HTMLInputElement>, data: CheckboxOnChangeData) => {
    if (typeof data.checked === 'boolean') {
      //setEnabled(data.checked)

      const params = new URLSearchParams(settings.params)
      if (data.checked) {
        params.delete(filterparamid);
        params.set(filterparamid, VALUEFALSE);
      } else if (params.has(filterparamid)) {
        params.delete(filterparamid);
      }

      settings.serialize(params)
    }
  }, [settings.params, filterparamid])

  const select = useCallback((ev: ChangeEvent<HTMLInputElement>, data: SwitchOnChangeData) => {
    const params = new URLSearchParams(settings.params)
    params.delete(filterparamid)

    params.set(filterparamid, data.checked ? VALUETRUE : VALUEFALSE)

    settings.serialize(params)
  }, [filter, settings.params, filterparamid])

  return (
    <Field label={filter.name}>
      <div className={classes.horizontal}>
        <Checkbox
          checked={enabled}
          onChange={toggle}
        />
        <Switch
          disabled={!enabled}
          checked={checked === undefined ? false : checked}
          onChange={select} />
      </div>
    </Field>
  )
})